// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__29vjN","clinicsSelect":"TableHeading_clinicsSelect__1UzWF"};